module.exports = __webpack_public_path__ + "static/media/temp_11.40db2fa2.jpg";